import { z } from 'zod'

export const RegistryCleanupRuleType = z.enum(['keep_last', 'untagged_ttl', 'tag_ttl'])
export type RegistryCleanupRuleType = z.infer<typeof RegistryCleanupRuleType>

export const RegistryCleanupRule = z.object({
  id: z.number(),
  repository: z.string(),
  rule_type: RegistryCleanupRuleType,
  value: z.number(),
  keep_patterns: z.array(z.string()).nullable().optional(),
  delete_patterns: z.array(z.string()).nullable().optional(),
  enabled: z.boolean()
})
export type RegistryCleanupRule = z.infer<typeof RegistryCleanupRule>

export const RegistryCleanupRuleCreateRequest = z.object({
  repository: z.string().min(1),
  rule_type: RegistryCleanupRuleType,
  value: z.number().int().min(1).max(3650),
  keep_patterns: z.array(z.string()).optional(),
  delete_patterns: z.array(z.string()).optional()
})
export type RegistryCleanupRuleCreateRequest = z.infer<typeof RegistryCleanupRuleCreateRequest>

export const RegistryCleanupRuleUpdateRequest = z.object({
  rule_type: RegistryCleanupRuleType,
  value: z.number().int().min(1).max(3650),
  keep_patterns: z.array(z.string()).optional(),
  delete_patterns: z.array(z.string()).optional(),
  enabled: z.boolean()
})
export type RegistryCleanupRuleUpdateRequest = z.infer<typeof RegistryCleanupRuleUpdateRequest>
